import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import styled from "styled-components";
export const CopyIcon = styled(ContentCopyIcon) `
    font-size: 20px !important;
    padding: 10px;
`;
